







































import Vue, { PropType } from 'vue'
import {
  parsePhoneNumber,
  ParseError,
  getCountries,
  getCountryCallingCode,
  CountryCode,
  CountryCallingCode,
  AsYouType,
} from 'libphonenumber-js'
import CountryFlag from 'vue-country-flag'
import { LocaleMessage } from 'vue-i18n'
import countries from '@/utils/countries'

type RuleType = (value: string) => boolean | string | LocaleMessage
interface Country {
  country: string
  callingCode: CountryCallingCode
}

export default Vue.extend({
  components: {
    appCountryFlag: CountryFlag,
  },
  props: {
    rules: {
      type: Array as PropType<RuleType[]>,
      required: false,
    },
    value: String,
    defaultCountry: {
      type: Object as PropType<Country>,
      required: false,
      default: () => countries[0],
    },
    noDefault: Boolean,
  },
  data() {
    return {
      model: '',
      countries: countries,
      countryCodes: getCountries(),
      country: null as null | Country,
      phoneRule: (v: string) => {
        if (!v) {
          return true
        }
        if (typeof v !== 'string') {
          return this.$t('introduce-a-number')
        }
        if (v.length < 4) {
          return this.$t('TOO_SHORT')
        }
        try {
          let value = v
          if (!value.includes('+')) {
            value = '+' + value
          }
          const number = parsePhoneNumber(value)
          if (number.countryCallingCode !== this.$data.country.callingCode) {
            this.$data.country = this.$data.countries.find(
              (country: Country) =>
                country.callingCode === number.countryCallingCode,
            )
          }
          this.$data.model = new AsYouType().input(value)
          this.$emit('input', this.$data.model)
          if (number.isValid()) {
            return true
          }
          return this.$t('invalid-phone')
        } catch (error) {
          if (error instanceof ParseError) {
            return this.$t(error.message)
          } else {
            return 'Error'
          }
        }
      },
    }
  },
  computed: {
    componentRules(): RuleType[] {
      return [...(this.rules || []), this.phoneRule]
    },
  },
  methods: {
    getCallingCode(code: string) {
      const newCode = code.toUpperCase() as CountryCode
      if (this.countryCodes.includes(newCode)) {
        return getCountryCallingCode(newCode)
      }
      return ''
    },
  },
  created() {
    this.country = this.defaultCountry || this.countries[0]
    if (this.value) {
      this.model = this.value
    } else if (!this.noDefault)
      this.model = ('+' + this.country.callingCode) as string
  },
  watch: {
    value(value) {
      this.model = value
    },
  },
})
